/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { PatientDmeViewModel } from './PatientDmeViewModel'; 

export function getPatientDmeListOptions(certificationPeriodId: string, onSuccess?: (result: PatientDmeViewModel[]) => void) {
	return queryOptions({
		queryKey: ['patient-dme-list', certificationPeriodId],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/careplanning/dme/queries/getpatientdmelist/' + certificationPeriodId;
			const resp = await axios.get<PatientDmeViewModel[]>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(certificationPeriodId)
	});
}